import data from 'app.data'
import PropTypes from 'prop-types'
import { createContext, useContext, useMemo, useState } from 'react'
import useRoutes from './hooks/useRoutes/useRoutes'

export const RootContext = createContext({})

// Use root context utility
export const useRootContext = () => useContext(RootContext)

/**
 *
 * @param {object} props - the component props
 * @param {any} props.children - the children
 * @returns {React.ReactElement} the element
 */
export default function RootProvider ({ children }) {
  const appData = useMemo(() => data, [])
  const { isRouteTransitioning, route, setDocumentTitle } = useRoutes(data)

  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false)

  const ctx = useMemo(
    () => ({
      appData,
      route,
      setDocumentTitle,
      isBurgerMenuOpen,
      setIsBurgerMenuOpen,
      isRouteTransitioning
    }),
    [appData, route, setDocumentTitle, isBurgerMenuOpen, isRouteTransitioning]
  )

  return <RootContext.Provider value={ctx}>{children}</RootContext.Provider>
}

RootProvider.propTypes = {
  children: PropTypes.node
}
